import { render, staticRenderFns } from "./Top-Trouble-Custom-Group.vue?vue&type=template&id=7b9d7dcd&"
import script from "./Top-Trouble-Custom-Group.vue?vue&type=script&lang=js&"
export * from "./Top-Trouble-Custom-Group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports